import react, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { chatHelpMessage, trackBtnClick } from "@/lib/helper";
import { NCR_REGIONS } from "@/lib/data";
import Div100vh from "react-div-100vh";
import PrimaryButton from "@/components/common/buttons/PrimaryButton";
import screenBgImage from "@/assets/images/screenBgImage.png";
import HeadingLine from "@/assets/images/headingLine.svg";
import LineLeft from "@/assets/images/lineLeft.svg";
import LineRight from "@/assets/images/lineRight.svg";
import LandlordWork1 from "@/assets/images/LandlordBene.svg";
import LandlordWork2 from "@/assets/images/landlord-work2.svg";
import LandlordWork3 from "@/assets/images/point-3.svg";
import TenantWork from "@/assets/images/tenant-work.svg";
import Header from "@/components/common/Header/header";
import TenantBenefits from "@/assets/images/tenant-benefits.png";
import LandlordBenefits from "@/assets/images/landlord-benefits.png";
import LandlordBenefits2 from "@/assets/images/landlord-benefits-2.png";
import PurpleBenefits from "@/assets/icons/purple-benefits.png";
// import WhatsappIcon from "@/assets/icons/whatsapp-icon-green.svg";
import WhatsappIcon from "@/assets/icons/whatsapp-icon.svg";
import { userDataAtom } from "@/recoil/atom/userDataAtom";
import { useRecoilValue } from "recoil";

export default function ClubWorkScreen({ isHome = false, handleButton }) {
  const navigate = useNavigate();
  const userData = useRecoilValue(userDataAtom);

  const handleNext = () => {
    trackBtnClick("Next", "Club Work Screen");
    navigate("/sign-up");
    return;
  };

  // return (
  //   <Div100vh
  //     className={` flex flex-col bg-gradient-to-b from-[#010101] via-[#000023] to-[#000050] bg-no-repeat bg-cover ${
  //       !isHome ? "justify-between gap-2 py-8 overflow-scroll" : "justify-start gap-16 py-12 se:h-[70%] sm:h-full se:overflow-scroll"
  //     }   px-8`}
  //     style={{
  //       backgroundImage: `linear-gradient(to bottom, rgba(1, 1, 1, 1) 10%, rgba(1, 1, 1, 1) 0%, rgba(1, 1, 1, 0) 100%),`,
  //       backgroundSize: "cover",
  //       backgroundPosition: "center",
  //     }}
  //   >
  //     <div className="flex flex-col items-center gap-8">
  //       {!isHome && <Header />}

  //       {isHome && (
  //         <button
  //           onClick={() => chatHelpMessage()}
  //           className="fixed top-6 right-6 rounded-xl flex text-[12px] items-center text-[#ededed] gap-2"
  //         >
  //           <img src={WhatsappIcon} alt="" className="max-w-10" />
  //         </button>
  //       )}

  //       <div className="flex flex-col items-center gap-2">
  //         <span className="text-white text-2xl font-medium font-['Montserrat']">
  //           Club Benefits
  //         </span>
  //         <img src={HeadingLine} alt="" />
  //       </div>
  //     </div>
  //     <div className="flex flex-col se:gap-8 sm:gap-12 items-center justify-center mb-4 text-center">
  //       {/* Tenant */}
  //       <div className="flex flex-col gap-6 items-center w-full mb-6">
  //         <div className="flex gap-4 w-full items-center flex-nowrap justify-center">
  //           <img
  //             src={LineLeft}
  //             alt="left-line"
  //             className="max-w-24 flex-shrink-0"
  //           />
  //           <span className="uppercase font-semibold whitespace-nowrap">
  //             For Tenants
  //           </span>
  //           <img
  //             src={LineRight}
  //             alt="right-line"
  //             className="max-w-24 flex-shrink-0"
  //           />
  //         </div>
  //         <div class="w-full border-[0.5px] rounded-lg text-sm border-[#999] py-4 px-8 bg-gradient-to-r from-gray-800 via-gray-900 to-black shadow-lg">
  //           <span class="text-green-400 font-medium italic">
  //             Zero Security Deposit
  //           </span><br/>
  //           <span class="text-white font-light mt-1">Move-In</span>
  //         </div>
  //       </div>

  //       {/* Landlord */}
  //       <div className="flex flex-col gap-8 items-center w-full">
  //         <div className="flex gap-4 w-full items-center flex-nowrap justify-center">
  //           <img
  //             src={LineLeft}
  //             alt="left-line"
  //             className="max-w-24 flex-shrink-0"
  //           />
  //           <span className="uppercase font-semibold whitespace-nowrap">
  //             For Landlords
  //           </span>
  //           <img
  //             src={LineRight}
  //             alt="right-line"
  //             className="max-w-24 flex-shrink-0"
  //           />
  //         </div>

  //         <div className="flex flex-col gap-6 text-sm w-full">

  //         <div class="w-full border-[0.5px] rounded-lg border-[#999] font-light   py-4 px-8 bg-gradient-to-r from-gray-800 via-gray-900 to-black/0 shadow-lg">
  //           <span class="text-green-400 font-medium italic">
  //           10 months{" "}
  //           </span>
  //           Advance Rent
  //           <p class="text-[#eee] font-light mt-1">(non-refundable)</p>
  //         </div>

  //         <div class="w-full border-[0.5px] rounded-lg border-[#999]  font-light  py-4 px-8 bg-gradient-to-r from-gray-800 via-gray-900 to-black/0 shadow-lg">
  //           <span class="text-green-400 font-medium italic">
  //           1 Month{" "}
  //           </span>
  //           Security Deposit
  //           <p class="text-white font-light mt-1"></p>
  //         </div>

  //         <div class="w-full border-[0.5px] rounded-lg border-[#999]  font-light  py-4 px-8 bg-gradient-to-r from-gray-800 via-gray-900 to-black/0 shadow-lg">
  //           <span class="text-green-400 font-medium italic">
  //           New Tenants{" "}
  //           </span>
  //           on renewal
  //           <p class="text-white font-light mt-1"></p>
  //         </div>

  //         </div>
  //         {/* <img src={LandlordWork2} alt="" />
  //         <img src={LandlordWork3} alt="" /> */}
  //       </div>
  //     </div>
  //     {!isHome && (
  //       <PrimaryButton text="Next" handleClick={() => handleNext()} />
  //     )}
  //     {isHome && (
  //       <div className="flex w-full h-16">

  //       </div>
  //     )}
  //   </Div100vh>
  // );

  return (
    <Div100vh
      className={`relative flex flex-col overflow-x-hidden bg-[#010101] ${
        !isHome
          ? "justify-between gap-2 p-6 sm:p-8 overflow-y-scroll"
          : "justify-start gap-8 py-12 se:h-[70%] sm:h-full se:overflow-y-scroll"
      } px-8`}
    >
      {/* Background Image Div */}
      <div
        className="absolute top-5 left-0 w-full z-0 scale-150"
        style={{
          height: "120px", // Set the height of the background area
          backgroundImage: `url(${PurpleBenefits})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      />

      {/* Content Div */}
      <div className="relative z-10 flex flex-col items-center gap-16">
        <Header customBackSubmit={handleButton} />
        {/* CLUB BENEFITS Section */}
        <div className="flex flex-col items-center gap-1">
          <span className="text-white text-xl font-medium font-['Montserrat']">
            CLUB BENEFITS
          </span>
          <img src={HeadingLine} alt="" className="max-w-[70%]" />
        </div>
      </div>

      <div>
        <img
          src={TenantBenefits}
          alt=""
          className="max-w-full pointer-events-none select-none"
        />
        <img
          src={
            NCR_REGIONS.includes(userData.moveInCity)
              ? LandlordBenefits2
              : LandlordBenefits
          }
          alt=""
          className="max-w-full pointer-events-none select-none"
        />
      </div>

      {!isHome && (
        <PrimaryButton text="Next" handleClick={() => handleNext()} />
      )}
      {/* {isHome && <div className="flex w-full h-16"></div>} */}
    </Div100vh>
  );
}
